module.exports = __webpack_public_path__ + "img/1502783314.1861f27c.jpg";